export * from './characteristics';
export * from './energy-label';
